const getters = {
    get_incident: (state) => state.incident_list,

    get_dni_search: (state) => state.dni_search,

    get_selected_incident: (state) => state.selected_incident


}
export default getters